import { ColumnDef } from "@tanstack/react-table";
import { useEffect, useState } from "react";
import api from "../../api/axios";
import { DataTable } from "../data-table/data-table";

export function LicenseCorrection() {

    const [access_code, setAccessCode] = useState('');
    const [uses, setUses] = useState(0);
    const [max_uses, setMaxUses] = useState(0);

    const updateLicenses = async () => {

        // validate data
        if (!access_code || (uses <= 0 && max_uses <= 0)) {
            alert("Invalid input data");
            return;
        }

        try {
            const response = await api.post('/updateLicense', {
                access_code,
                uses,
                max_uses
            });

            alert(response.data.message);

        } catch (error) {
            alert("Error updating licenses");
        }
    }

    return (
        <div className="license-correction">
            <div>Code</div>
            <input
                type="text"
                value={access_code}
                onChange={(e) => setAccessCode(e.target.value)}
                placeholder="Zugangs-Code"
            />
            <div>Anzahl der Verwendungen (uses)</div>
            <input
                type="number"
                value={uses}
                onChange={(e) => setUses(Number(e.target.value))}
                placeholder="Anzahl der Verwendungen"
                min={0}
                style={{opacity: uses > 0 ? 1 : 0.2}}
            />
            <div>Maximale Anzahl der Verwendungen (max_uses)</div>
            <input
                type="number"
                value={max_uses}
                onChange={(e) => setMaxUses(Number(e.target.value))}
                placeholder="Maximale Anzahl der Verwendungen"
                min={0}
                style={{opacity: max_uses > 0 ? 1 : 0.2}}
            />
            <div></div>
            <button onClick={() => updateLicenses()}>Aktualisieren</button>
        </div>
    );
}